/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {
    Component,
    ComponentFactoryResolver,
    ElementRef,
    Injector,
    Type,
    ViewChild,
    ViewContainerRef, ComponentRef
} from '@angular/core';
import { FcResponsiveAgDialogComponent } from './fc-responsive-ag-dialog.component';

/**
 * The modal backdrop wrapping wrapper to the modal.
 */
@Component({
    selector: 'fc-responsive-ag-dialog-wrapper',
    templateUrl: './fc-responsive-ag-dialog-wrapper.component.html'
})
export class FcResponsiveAgDialogWrapperComponent {
    /**
     * Target viewContainer to insert modal content component.
     */
    @ViewChild('viewContainer', { read: ViewContainerRef, static: true }) viewContainer: any;

    /**
     * Link wrapper DOM element.
     */
    @ViewChild('wrapper', { read: ElementRef, static: true })
        wrapper: ElementRef

    /**
     * Wrapper modal and fade classes.
     */
    modalClasses: string = 'modal fade-anim';

    /**.
     * Dialog content component
     *
     * @type {FcResponsiveAgDialogComponent}
     */
    content: FcResponsiveAgDialogComponent;
    
    /**
     * Component constructor.
     *
     * @param resolver Component factory resolver.
     */
    constructor(private resolver: ComponentFactoryResolver) {}

    /**
     * Adds content modal component to wrapper.
     * 
     * @param component Component instance.
     * @returns Component Component instance.
     */
    addComponent(component: Type<FcResponsiveAgDialogComponent>): 
        {ref: ComponentRef<FcResponsiveAgDialogComponent>, component: FcResponsiveAgDialogComponent} {
        const factory = this.resolver.resolveComponentFactory(component);
        const injector = Injector.create({
            providers: [],
            parent: this.viewContainer.injector
        });
        const componentRef = factory.create(injector);
        this.viewContainer.insert(componentRef.hostView);
        this.content = <FcResponsiveAgDialogComponent>componentRef.instance;
        this.content.wrapper = this.wrapper;
        return {ref: componentRef, component: this.content};
    }
}